var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailSent = function SvgEmailSent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 74
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCE54",
    fillRule: "nonzero",
    d: "M25.19 17.168c-1.619-.18-4.053.41-5.41 1.315L2.494 30.009c-1.356.904-2.465 2.976-2.465 4.606v35.548a2.97 2.97 0 0 0 2.962 2.962h65.174a2.97 2.97 0 0 0 2.961-2.962V34.615c0-1.63-1.109-3.702-2.464-4.607l-11.93-7.952c-1.356-.904-3.788-1.792-5.409-1.972L25.19 17.168z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BB42",
    fillRule: "nonzero",
    d: "m51.324 20.084-13.068-1.458-13.066-1.458c-1.619-.18-4.05.41-5.407 1.313l-8.646 5.765-8.644 5.763C1.668 30.557.935 31.54.488 32.59l35.034 23.038 35.115-23.105c-.451-1.024-1.17-1.976-1.977-2.515l-5.964-3.977-5.967-3.977c-1.356-.902-3.786-1.788-5.405-1.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED5564",
    fillRule: "nonzero",
    d: "M39.955 55.628a4.444 4.444 0 1 1-8.888 0 4.444 4.444 0 0 1 8.888 0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#37A3BC"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.361 10.71-.028-.024a4.763 4.763 0 0 0-6.729 0l-.897.898a.96.96 0 1 0 1.358 1.357l.897-.897c1.107-1.107 2.907-1.107 4.043.028l.028.024c.534.534.828 1.248.828 2.01a2.82 2.82 0 0 1-.828 2.009l-4.81 4.81a2.842 2.842 0 0 1-4.015-.002l-.056-.056a2.843 2.843 0 0 1-.007-4.011l.22-.216a.96.96 0 1 0-1.342-1.372l-.229.223a4.768 4.768 0 0 0 .002 6.735l.056.056a4.743 4.743 0 0 0 3.365 1.391 4.742 4.742 0 0 0 3.364-1.391l4.81-4.81a4.728 4.728 0 0 0 1.39-3.366c0-1.275-.494-2.47-1.42-3.395z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.976 22.74-.898.898a2.818 2.818 0 0 1-2.007.828c-.76 0-1.473-.294-2.038-.857l-.026-.024a2.845 2.845 0 0 1 0-4.018l4.81-4.81a2.842 2.842 0 0 1 4.013 0l.058.058c.534.534.827 1.247.827 2.009 0 .762-.293 1.475-.82 2.002l-.22.216a.96.96 0 1 0 1.342 1.372l.228-.223a4.728 4.728 0 0 0 1.39-3.367c0-1.275-.493-2.47-1.39-3.367l-.057-.058a4.763 4.763 0 0 0-6.729 0l-4.81 4.81c-1.856 1.857-1.856 4.877.031 6.763l.027.023a4.725 4.725 0 0 0 3.364 1.39 4.725 4.725 0 0 0 3.365-1.39l.897-.897a.96.96 0 1 0-1.357-1.358z"
  }))))));
};
export default SvgEmailSent;